import axios from "axios";
import Constants from "../../utils/Constantes";

const API_URL = Constants.api_url;
const GET_LISTA_ADMIN = `${API_URL}/administrador/`;

export async function getListaAdmin() {
  return await axios({
    method: "GET",
    url: GET_LISTA_ADMIN,
  })
    .then((response) => {
      
      return response.data;
    })
    .catch(
      (response) =>
        (response.data = "Error: Fallo al obtener los administradores")
    );
}

export async function getAdminById(id) {
  return await axios({
    method: "GET",
    url: `${GET_LISTA_ADMIN}${id}`,
  })
    .then((response) => {
      
      return response.data;
    })
    .catch(
      (response) =>
        (response.data = "Error: Fallo al obtener administrador por id")
    );
}

export async function insertarAdmin(adminDTO) {
  return await axios({
    method: "POST",
    url: GET_LISTA_ADMIN,
    data: adminDTO,
  })
    .then((response) => {
      
      return response.data;
    })
    .catch(
      (response) =>
        (response.data = "Error: Fallo al insertar un administrador")
    );
}

  export async function actualizarAdmin(id,adminDTO) {
    return await axios({
      method: "PUT",
      url: `${GET_LISTA_ADMIN}${id}`,
      data:adminDTO
    })
    .catch(
      (response) =>
        (response.data = "Error: Fallo al actualiar el administrador")
    );
}

export async function borrarAdmin(id) {
  return await axios({
    method: "DELETE",
    url: `${GET_LISTA_ADMIN}${id}`,
  })
    .then((response) => {
      
      return response.data;
    })
    .catch(
      (response) =>
        (response.data = "Error: Fallo al borrar el administrador")
    );
}

